import store from "@src/reducers/store";
import { calculateValuesInterval } from "@src/components/molecules/time-series-line-graph-wrapper/calculate-values-interval";
import { calculateZoomStart } from "@src/components/molecules/time-series-line-graph-wrapper/calculate-zoom-range";
import { buildGraphOptionObject } from "@src/components/molecules/time-series-line-graph-wrapper/build-option-object";
import { truncateStringAndAddEllipsis } from "@src/cloud-connect/utils/truncate-string-and-add-ellipsis";
import { findNonArrayValuesInLastElement } from "@src/components/organisms/node-details-panel/last-actual-value-and-timestamp-if-json/find-non-array-values-in-last-array-element";
import { mergeArrays } from "@src/cloud-connect/utils/merge-arrays";
import { fetchNodeTimeseriesDataWithNodeId } from "../api/timeseries/fetch-node-timeseries-with-node-id";

// const namespace = "11657baf-3052-481c-a7ee-d0ec7c12e627";
// const ts_uuid = "043ed156-617b-5e31-8da1-74e815a0d646";

const useMockedParams = false;
const fakeNodeId =
  "device_name=Qeed_Energy_Meter;function_code=3;reg_addr=723;reg_count=4;data_type=12;com_port=COM1";

const getGroupId = () => {
  let group_id = "";

  if (useMockedParams) {
    group_id = "f6a30c0cd9b5";
  } else {
    group_id = store.getState().yourSlice.connectionView.source.source_id;
  }

  return group_id;
};

const getNodeId = (nodeId) => {
  if (useMockedParams) {
    return fakeNodeId;
  }

  return nodeId;
};

export const fetchTimeseriesData = async (
  nodeName,
  nodeId,
  unitDisplayName,
  showDataZoom,
  setLastKnownValueAndTimestamp,
  setTimeseriesDataType,
  setTsid,
  setGraphOptionsObject,
  setStringDataAndTimestampData,
) => {
  try {
    const graphData = await fetchNodeTimeseriesDataWithNodeId(
      getGroupId(),
      getNodeId(nodeId),
    );

    setStringDataAndTimestampData(null);

    if (!graphData) {
      setLastKnownValueAndTimestamp(null);
      setGraphOptionsObject(null);
      setTimeseriesDataType(null);
      setTsid(null);
    } else if (
      graphData &&
      graphData.data &&
      (!graphData.data.valuesArray || graphData.data.valuesArray.length === 0)
    ) {
      setLastKnownValueAndTimestamp(null);
      setGraphOptionsObject(null);
      setTsid(graphData.tsid);
      setTimeseriesDataType(graphData.data.dataType);
    } else if (
      graphData &&
      graphData.data &&
      graphData.data.dataType === "string"
    ) {
      setTimeseriesDataType(graphData.data.dataType);

      setLastKnownValueAndTimestamp({
        value:
          graphData.data.valuesArray[graphData.data.valuesArray.length - 1] !==
          ""
            ? truncateStringAndAddEllipsis(
                graphData.data.valuesArray[
                  graphData.data.valuesArray.length - 1
                ],
              )
            : "Empty string",
        timestamp:
          graphData.data.timesArray[graphData.data.timesArray.length - 1],
      });
      setTsid(graphData.tsid);
      setGraphOptionsObject(null);

      // temporary fix: since limit for the request is 50000, for strings we are
      // cutting off all elements after the 2000th to avoid DOM overload
      // https://linear.app/tomorrowthings/issue/TO-1864/bug-latest-value-not-displayed-in-fe-tree-structure-side-panel#comment-966ed98a
      setStringDataAndTimestampData(
        mergeArrays(
          graphData.data.timesArray.reverse().slice(0, 2000),
          graphData.data.valuesArray.reverse().slice(0, 2000),
        ),
      );
    } else if (graphData.data.dataType === "json") {
      setLastKnownValueAndTimestamp({
        value: findNonArrayValuesInLastElement(graphData.data.valuesArray),
        timestamp:
          graphData.data.timesArray[graphData.data.timesArray.length - 1],
      });
      setTsid(graphData.tsid);
      setGraphOptionsObject(null);
      setTimeseriesDataType(graphData.data.dataType);
    } else {
      const { yAxisMin, yAxisMax } = calculateValuesInterval(
        graphData.data.valuesArray,
        "20%",
      );

      const zoomStart = calculateZoomStart(graphData.data.valuesArray);
      setLastKnownValueAndTimestamp({
        value:
          graphData.data.valuesArray[graphData.data.valuesArray.length - 1],
        timestamp:
          graphData.data.timesArray[graphData.data.timesArray.length - 1],
      });
      setTimeseriesDataType(graphData.data.dataType);
      setTsid(graphData.tsid);
      setGraphOptionsObject(
        buildGraphOptionObject({
          nodeName,
          valuesArray: graphData.data.valuesArray,
          timesArray: graphData.data.timesArray,
          yAxisMin,
          yAxisMax,
          zoomStart,
          unitDisplayName,
          showDataZoom,
          valueOnly: true,
        }),
      );
    }
  } catch (error) {
    console.error("Error fetching data:", error);
  }
};
